import {atom} from "nanostores"

export const $language = atom({})
export const $languageId = atom("")
export const $languageIso = atom("")
